import React from "react";
import { Collapse } from "antd";
import ProductStockEvolution from "./ProductStockEvolution";

const { Panel } = Collapse;

const SupportInfoPanel = ({
  campaignInfoPanel,
  productStockPanel,
  printersStockPanel,
  orderEvolutionPanel,
  costsPanel,
  campaigns,
}) => (
  <Collapse
    bordered={false}
    defaultActiveKey={["campaignInfo"]}
    style={{ background: "none" }}
    className="small-font">
    <Panel header="Campaigns on Mail Date" key="campaignInfo">
      {campaignInfoPanel}
    </Panel>
    <Panel header="Strategy" key="strategy">
      <Collapse bordered={false} ghost>
        <Panel header="Costs" key="costs">
          {costsPanel}
        </Panel>
      </Collapse>
    </Panel>
    <Panel header="Product Stock" key="productStock">
      {productStockPanel}
    </Panel>
    <Panel header="Product Stock Evolution" key="productStockEvolution">
      <ProductStockEvolution campaigns={campaigns} />
    </Panel>
    <Panel header="Print Stock" key="printersStock">
      {printersStockPanel}
    </Panel>

    <Panel header="Order Evolution" key="orderEvolution">
      {orderEvolutionPanel}
    </Panel>
  </Collapse>
);

export default SupportInfoPanel;
